import { render } from "./Membership.vue?vue&type=template&id=5faca526&scoped=true"
const script = {}

import "./Membership.vue?vue&type=style&index=0&id=5faca526&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5faca526"

export default script